module.exports = __webpack_public_path__ + "141b4095f5a5f6a3e153aeaccba880bf.png";